import AcceptedDeliveryTimeButtons from '@/components/OrdersModule/OrderDetail/Footer/AcceptedDeliveryTimeSelector/AcceptedDeliveryTimeButtons'
import { requestedDeliveryTimeShiftValues } from '@/constants/order-flow-action-time-values'
import { DeliveryTime } from '@/features/orders/types/app'
import Chip from '@/features/ui/components/Chip'
import { RequestedDeliveryTimeShiftValues } from '@/types/order-flow-action-time-values'
import { formatDeliveryTime } from '@/utils/formatDeliveryTime'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface DefaultAcceptedDeliveryTimeProps {
    requestedDeliveryTime: DeliveryTime
    customDeliveryTime: DeliveryTime | undefined
    shiftValue: RequestedDeliveryTimeShiftValues
    onDeliveryTimeShiftPress: (value: RequestedDeliveryTimeShiftValues) => void
    onOrderCancelButton: () => void
    onOrderAcceptButton: () => Promise<void>
}

const DefaultAcceptedDeliveryTimeSelector: FC<DefaultAcceptedDeliveryTimeProps> = ({
    requestedDeliveryTime,
    customDeliveryTime,
    shiftValue,
    onDeliveryTimeShiftPress,
    onOrderCancelButton,
    onOrderAcceptButton,
}) => {
    const { t } = useTranslation()

    return (
        <View style={styles.content}>
            <View style={styles.container}>
                {requestedDeliveryTimeShiftValues.map((value, index) => {
                    if (value === 0) {
                        return (
                            <Chip
                                key={index}
                                label={t('order.detail.requiredTime')}
                                subText={formatDeliveryTime(requestedDeliveryTime)}
                                active={shiftValue === 0}
                                onPress={() => onDeliveryTimeShiftPress(value)}
                                style={styles.wideChip}
                            />
                        )
                    }

                    if (value === 'custom') {
                        return (
                            <Chip
                                key={index}
                                label={t('order.detail.customTime')}
                                subText={
                                    customDeliveryTime && formatDeliveryTime(customDeliveryTime)
                                }
                                active={shiftValue === 'custom'}
                                onPress={() => onDeliveryTimeShiftPress('custom')}
                                style={styles.wideChip}
                            />
                        )
                    }

                    return (
                        <Chip
                            key={index}
                            label={`${value > 0 ? '+' : ''}${value} ${t('timeUnit.min')}`}
                            active={shiftValue === value}
                            onPress={() => onDeliveryTimeShiftPress(value)}
                            style={styles.shortChip}
                        />
                    )
                })}
            </View>
            <AcceptedDeliveryTimeButtons
                onOrderCancel={onOrderCancelButton}
                onOrderAccept={onOrderAcceptButton}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    content: {
        alignSelf: 'stretch',
        alignItems: 'center',
    },
    container: {
        flexWrap: 'wrap',
        width: 344,
        flexDirection: 'row',
        marginBottom: 12,
        gap: 8,
    },
    wideChip: {
        width: 168,
    },
    shortChip: {
        width: 80,
    },
})

export default DefaultAcceptedDeliveryTimeSelector
